var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"3e59c12ffb2918c095556901c6b7136e21b6efd4"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { init, Replay } from '@sentry/nextjs';

import { SENTRY_DSN } from '@/next.constants.mjs';

init({
  // tell Sentry where to send events
  dsn: SENTRY_DSN,
  // percentage of events to send to Sentry (all of them)
  tracesSampleRate: 1,
  // percentage of errors to sample (all of them)
  replaysOnErrorSampleRate: 1.0,
  // percentage of sessionsto sample (10%)
  replaysSessionSampleRate: 0.1,
  integrations: [new Replay()],
});
